<template>
  <div class="ai-autopilot-content-review">
    <div class="ai-autopilot-content-review__wrapper">
      <div v-if="review.linkToOrgloc" class="ai-autopilot-content-review__business">
        <i class="fa-regular fa-briefcase mr-1" />
        <a :href="review.linkToOrgloc" target="_blank">{{ review.locationName }}</a>
      </div>
      <div class="ai-autopilot-content-review__author">
        <div v-if="review.reviewer.profilePhotoUrl" class="ai-autopilot-content-review__avatar">
          <img :src="review.reviewer.profilePhotoUrl" :alt="`${review.reviewer.displayName} avatar`">
        </div>
        <div v-else class="ai-autopilot-content-review__avatar">
          <span>
            {{ reviewAuthorInitials }}
          </span>
        </div>
        <span>{{ review.reviewer.displayName }}</span>
      </div>
      <div class="ai-autopilot-content-review__body">
        <div class="ai-autopilot-content-review__rating">
          <i v-for="i in 5" :key="i"
            class="fa-solid fa-star"
            :class="{ 'active': i <= review.starRating }" />
          <span class="ai-autopilot-content-review__date">{{ review.remoteCreatedAt }}</span>
        </div>
        <p>{{ formattedReviewText }}</p>
      </div>
      <div v-if="review.reviewReply && !preview" class="ai-autopilot-content-review__response">
        <h3>Existing reply</h3>
        <span>{{ review.reviewReply.createdAt }}</span>
        <p>{{ formattedReviewReplyText }}</p>
      </div>
    </div>
    <div class="ai-autopilot-content-review__generated-content">
      <div v-if="review.previewReplies">
        <div v-for="(previewReply, previewIndex) in review.previewReplies"
          class="ai-autopilot-content-review__wrapper"
          :key="previewIndex">
          <p class="ai-autopilot-content-review__response-title">Example reply {{ previewIndex + 1 }}:</p>
          <p class="ai-autopilot-content-review__response-text">{{ previewReply }}</p>
        </div>
      </div>
      <div v-else-if="!editReply" class="ai-autopilot-content-review__wrapper">
        <p class="ai-autopilot-content-review__response-title">AI Reply:</p>
        <p class="ai-autopilot-content-review__response-text">
          {{ task.content.text }}
        </p>
      </div>
      <div v-else class="ai-autopilot-content-review__wrapper">
        <textarea
          v-model="editableText"
          class="form-control"
          placeholder="Write an answer or generate it" />
        <button
          class="btn btn-xs px-2 btn-primary rounded mt-2"
          @click="$emit('update', editableText)">
          <span>Save and Approve</span>
        </button>
      </div>
      <div v-if="allowActions" class="ai-autopilot-content-review__generation-actions">
        <button
          :id="`edit-task-${task.id}`"
          class="btn btn-link"
          @click="toggleEditReply">
          <i class="fa-regular mr-2" :class="editReply ? 'fa-xmark' : 'fa-edit'" />
          <b-popover
            :target="`edit-task-${task.id}`"
            placement="top"
            custom-class="geogrids-popover p-1"
            triggers="hover">
            {{ manualReplyEditTooltip }}
          </b-popover>
        </button>
        <button
          v-if="canRegenerate"
          :id="`regenerate-task-${task.id}`"
          class="btn btn-link"
          @click="$emit('regenerate')">
          <i class="fa-regular fa-rotate mr-2" />
          <b-popover
            :target="`regenerate-task-${task.id}`"
            placement="top"
            custom-class="geogrids-popover p-1"
            triggers="hover">
            Regenerate reply
          </b-popover>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    task: {
      type: Object,
      required: true
    },
    canRegenerate: {
      type: Boolean,
      required: false,
      default: false
    },
    allowActions: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      editReply: false,
      editableText: this.task.content.text
    }
  },
  created() {
    // TODO: Remove this when backend will be ready
    this.review = this.task.content.review
    this.translationFormatRegexp = /(\(Translated by Google\)|\(Original\))/g
  },
  methods: {
    formatCommentText(comment) {
      if (!comment) return ''
      const formatted = comment.replace(this.translationFormatRegexp, '\n$1:\n').trim()
      return formatted.replace(/\n{2,}/g, '\n')
    },
    toggleEditReply() {
      if (this.editReply) {
        this.editableText = this.task.content.text
      }

      this.editReply = !this.editReply
    }
  },
  computed: {
    formattedReviewText() {
      return this.formatCommentText(this.review.comment)
    },
    formattedReviewReplyText() {
      return this.formatCommentText(this.review.reviewReply?.comment)
    },
    manualReplyEditTooltip() {
      return this.editReply ? 'Cancel' : 'Edit reply manually'
    },
    reviewAuthorInitials() {
      return this.review.reviewer.displayName.split(' ').map((part) => part[0]).join('')
    }
  }
}
</script>
